import { CommonModule } from "@angular/common";
import { NgModule } from "@angular/core";
import { ReactiveFormsModule } from "@angular/forms";
import { InputSwitchModule } from "primeng/inputswitch";
import { LazyTooltipModule } from "../../../shared/directives/lazy-tooltip/lazy-tooltip.module";
import { ToolTipModule } from "../../../shared/tool-tip/tool-tip.module";
import { SwitchComponent } from "./switch.component";

@NgModule({
  imports: [
    CommonModule,
    InputSwitchModule,
    ReactiveFormsModule,
    ToolTipModule,
    LazyTooltipModule,
  ],
  declarations: [
    SwitchComponent,
  ],
  entryComponents: [
    SwitchComponent,
  ],
  exports: [
    SwitchComponent,
  ],
})
export class SwitchModule { }
